import axios from "axios";
import { auth } from "./firebase";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;

    if (user) {
      try {
        const token = await user.getIdToken();
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      } catch (err) {
        return Promise.reject(
          new Error("Session expired. Please sign in again."),
        );
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRoute = error.config?.url?.includes("/auth/login");

    // Only redirect on 401 for protected routes, never for login attempts
    if (error.response?.status === 401 && !isLoginRoute) {
      auth.signOut();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default api;
